<template>
  <DSPopover
    v-if="hasUnread"
    v-model:open="open"
  >
    <DSPopoverTrigger as-child>
      <slot />
    </DSPopoverTrigger>
    <DSPopoverContent
      align="end"
      class="w-95 p-0 overflow-hidden"
    >
      <AppNotifications
        :notifies
        :errors
        class="w-full!"
        @click:item="open = false"
      />
    </DSPopoverContent>
  </DSPopover>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useAppNotifications } from '../utils/useAppNotifications'

import { DSPopover, DSPopoverContent, DSPopoverTrigger } from '@ds'
import { AppNotifications } from '@app'


const { errors, notifies, hasUnread } = useAppNotifications()

const open = ref(false)
</script>
